import { render } from "./ClaimUpdateEstalyManagerNotesModal.vue?vue&type=template&id=b7f88c34"
import script from "./ClaimUpdateEstalyManagerNotesModal.vue?vue&type=script&lang=js"
export * from "./ClaimUpdateEstalyManagerNotesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__